<template>
  <div id="navigation-drawer-view">
    <v-container fluid>
      <v-layout row justify-center>
        <v-flex xs10>
          <v-card class="mt-3" color="blue darken-1 white--text">
            <v-card-text>
              <v-layout row justify-center>
                <div class="display-1 my-3">Controla, protege y asegura tu cuenta, todo en un solo lugar</div>
              </v-layout>
              <v-layout row justify-center>
                <div class="body-1">
                  Mi Cuenta te da un rápido acceso a configuraciones y herramientas
                  que te permiten salvaguardar tu información, proteger tu privacidad y
                  decidir como tu información puede mejorar los servicios de Rastreo Siglo XXI para ti.
                </div>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout row justify-space-around wrap>
        <password
          :loading="passwordFormLoading"
          @update-password="updatePassword"
          ref="passwordForm"
        ></password>
        <personal-data
          :client="client"
          :loading="personalDataFormLoading"
          :creating-email="creatingEmail"
          :removing-email="removingEmail"
          @update-personal-data="updatePersonalData"
          @create-email="createEmail"
          @remove-email="removeEmail"
          ref="personalDataForm"
        ></personal-data>
      </v-layout>
    </v-container>
    <snackbar ref="snackbar"></snackbar>
  </div>
</template>

<script>
import Password from '@/components/Profile/Password'
import PersonalData from '@/components/Profile/PersonalData'
import Snackbar from '@/components/Snackbar'

export default {
  name: 'profile',
  data: function () {
    return {
      passwordFormLoading: false,
      personalDataFormLoading: false,
      creatingEmail: false,
      removingEmail: false
    }
  },
  computed: {
    client: function () {
      return this.$store.state.Account.client
    }
  },
  created: function () {
    this.$store.dispatch('Account/fetchClient')
  },
  components: {
    'password': Password,
    'personal-data': PersonalData,
    'snackbar': Snackbar
  },
  methods: {
    updatePassword: async function ({ oldPassword, newPassword }) {
      this.passwordFormLoading = true
      try {
        await this.$store.dispatch('Account/updateClientPassword', {
          client: {
            oldPassword,
            newPassword
          }
        })
      } catch (e) {
        this.passwordFormLoading = false
        const passwordForm = this.$refs.passwordForm
        const message = e.graphQLErrors[0] ? e.graphQLErrors[0].message : 'Ooops, ha ocurrido un error'
        passwordForm.openAlert(message)
        return console.error(e)
      }
      this.passwordFormLoading = false
      this.$refs.snackbar.open('success', 'Contraseña actualizada')
    },
    updatePersonalData: async function ({ name }) {
      this.personalDataFormLoading = true
      try {
        await this.$store.dispatch('Account/updateClient', {
          client: { name }
        })
      } catch (e) {
        this.personalDataFormLoading = false
        const personalDataForm = this.$refs.personalDataForm
        const message = e.graphQLErrors[0] ? e.graphQLErrors[0].message : 'Ooops, ha ocurrido un error'
        personalDataForm.openAlert(message)
        return console.error(e)
      }
      this.personalDataFormLoading = false
      this.$refs.snackbar.open('success', 'Información personal actualizada')
    },
    createEmail: async function ({ email }) {
      this.creatingEmail = true
      try {
        await this.$store.dispatch('Account/createEmail', {
          email
        })
      } catch (e) {
        this.creatingEmail = false
        const personalDataForm = this.$refs.personalDataForm
        const message = e.graphQLErrors[0] ? e.graphQLErrors[0].message : 'Ooops, ha ocurrido un error'
        personalDataForm.openAlert(message)
        return console.error(e)
      }
      this.creatingEmail = false
      this.$refs.snackbar.open('success', 'Activa tu correo electrónico')
    },
    removeEmail: async function ({ email }) {
      this.removingEmail = true
      try {
        await this.$store.dispatch('Account/removeEmail', {
          email
        })
      } catch (e) {
        this.removingEmail = false
        const personalDataForm = this.$refs.personalDataForm
        const message = e.graphQLErrors[0] ? e.graphQLErrors[0].message : 'Ooops, ha ocurrido un error'
        personalDataForm.openAlert(message)
        return console.error(e)
      }
      this.removingEmail = false
      this.$refs.snackbar.open('success', 'Correo electrónico eliminado')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Profile.vue